export default "__VITE_ASSET__BBxOE76r__"